import React from "react";
import { getCodeFolderDelete, getCodeFolderSave } from "../actions/folder";
import { getCodeFileDelete, getCodeFileSave } from "../actions/file";
import { connect } from "react-redux";
import { tempAlWait } from "../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFile, faFileCirclePlus, faFolder, faFolderPlus, faPen, faTrashCan, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

class AdminItemFolder extends React.Component {
    state = {
        optActive: false,
        isEdit: false,
        name: '',
        activeModal: false,
        form: {
            name: '',
            code: ''
        },
        hasNewFolder: false,
        activeFile: null,
        nameNewFolder: null
    }

    componentDidMount() {
        this.setState({
            name: this.props.data.name,
            hasNewFolder: false
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.redCdFldSave != prevProps.redCdFldSave) {
            if (this.state.hasNewFolder) {
                this.props.refreshList(true);
                this.setState({
                    hasNewFolder: false
                })
            }
            if (this.props.redCdFldSave.isNext) {
                this.setState({
                    isEdit: false,
                    hasNewFolder: false,
                })
            }
            this.props.changeAlert(this.props.redCdFldSave.alert);

        }

        if (this.props.redCdFldDel != prevProps.redCdFldDel) {
            if (this.props.redCdFldDel.isNext) {
                this.props.refreshList(true);
            }
            this.props.changeAlert(this.props.redCdFldDel.alert);
        }

        if (this.props.redCdFlSave != prevProps.redCdFlSave) {
            if (this.props.redCdFlSave.isNext) {
                this.setState({
                    activeModal: false,
                    activeFile: null
                });
                setTimeout(() => {
                    this.props.refreshList(true); 
                }, (2000));
            }
            this.props.changeAlert(this.props.redCdFlSave.alert);
        }

        if (this.props.redCdFlDel != prevProps.redCdFlDel) {
            if (this.props.redCdFlDel.isNext) {
                this.props.refreshList(true);
            }
            this.props.changeAlert(this.props.redCdFlDel.alert);
        }
    }

    handleSaveFolder(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.getCodeFolderSave({
            idFolder: this.props.data.id,
            idFolderAdult: this.props.idFolderAdult,
            idProject: null,
            name: this.state.name
        });
    }

    handleSaveNewFolder(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.getCodeFolderSave({
            idFolder: null,
            idFolderAdult: this.props.data.id,
            idProject: null,
            name: this.state.nameNewFolder
        })
    }

    handleDeleteFolder(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        });
        this.props.getCodeFolderDelete({
            idFolder: this.props.data.id
        })
    }

    handleSaveFile(el) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        });
        this.props.getCodeFileSave({
            idFile: this.state.activeFile,
            name: this.state.form.name,
            code: this.state.form.code,
            idFolder: this.props.data.id
        });
    }

    handleDeleteFile(el, id) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        });
        this.props.getCodeFileDelete({
            idFile: id
        })
    }

    render() {
        return <li className="admin__itemfldr">
            {/** Nom **/}
            <div className="admin__itemfldr__parent">
                <FontAwesomeIcon icon={faFolder} />
                {
                    this.state.isEdit ?
                        <div className="admin__item__formline">
                            <input
                                value={this.state.name}
                                onChange={(el) => this.setState({name: el.target.value})}
                                className="admin__item__inputline"
                                title="Nom du dossier"
                                aria-label="Nom du dossier"
                            />
                            <button
                                title="Enregistrer le nom"
                                aria-label="Enregistrer le nom"
                                className="admin__item__eyebtn"
                                onClick={(el) => this.handleSaveFolder(el)}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>
                        </div> :
                        <p className="admin__item__text">
                            {this.state.name}
                        </p>
                }
            </div>
            
            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Ajouter un dossier **/}
                <button
                    title="Ajouter un dossier"
                    aria-label="Ajouter un dossier"
                    className="admin__item__optbtn"
                    onClick={() => {
                        this.setState({
                            hasNewFolder: true,
                            nameNewFolder: ''
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faFolderPlus} />
                </button>

                {/** Ajouter un fichier **/}
                <button
                    title="Ajouter un fichier"
                    aria-label="Ajouter un fichier"
                    className="admin__item__optbtn"
                    onClick={() => {
                        this.setState({
                            activeModal: true,
                            form: {
                                name: '',
                                code: ''
                            },
                            activeFile: null
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faFileCirclePlus} />
                </button>

                {/** Modifier **/}
                <button
                    title="Modifier le dossier"
                    aria-label="Modifier le dossier"
                    className="admin__item__optbtn"
                    onClick={() => this.setState({isEdit: !this.state.isEdit})}
                >
                    <FontAwesomeIcon icon={faPen} />
                </button>

                {/** Supprimer **/}
                <button
                    title="Supprimer le dossier"
                    aria-label="Supprimer le dossier"
                    className="admin__item__optbtn admin__item__optbtn--del"
                    onClick={() => this.handleDeleteFolder(this.props.data.id)}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            </div>

            {/** Sous dossiers et fichier **/}
            {
                (this.props.data.foldersChild.length > 0 ||
                this.props.data.files.length > 0 ||
                this.state.hasNewFolder
                ) &&
                <ul className="admin__itemfldrlist">
                    {/** Sous dossiers **/}
                    {
                        this.props.data.foldersChild
                            .sort((a, b) => {
                                if (a.name < b.name) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            })
                            .map((data, key) => {
                            return <AdminItemFolder
                                data={data}
                                key={`subfolder-${key}`}
                                changeAlert={(alert) => this.props.changeAlert(alert)}
                                refreshList={(doRefresh) => this.props.refreshList(doRefresh)}
                                idFolderAdult={this.props.data.id}
                                getCodeFolderSave={this.props.getCodeFolderSave}
                                getCodeFolderDelete={this.props.getCodeFolderDelete}
                                getCodeFileSave={this.props.getCodeFileSave}
                                getCodeFileDelete={this.props.getCodeFileDelete}
                            />
                        })
                    }
                    {
                        this.state.hasNewFolder &&
                        <div className="admin__item__formline">
                            <input
                                value={this.state.nameNewFolder}
                                onChange={(el) => this.setState({nameNewFolder: el.target.value})}
                                className="admin__item__inputline"
                                title="Nom du nouveau dossier"
                                aria-label="Nom du nouveau dossier"
                                placeholder="Nom du nouveau dossier"
                            />
                            <button
                                title="Enregistrer le dossier"
                                aria-label="Enregistrer le dossier"
                                className="admin__item__eyebtn"
                                onClick={(el) => this.handleSaveNewFolder(el)}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>
                        </div>
                    }
                    {/** Sous fichiers **/}
                    {
                        this.props.data.files
                            .sort((a, b) => {
                                if (a.name < b.name) {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            })
                            .map((data, key) => {
                            return <li className="admin__itemfldr" key={`file-${key}`}>
                                {/** Nom **/}
                                <div className="admin__itemfldr__parent">
                                    <FontAwesomeIcon icon={faFile} />
                                    <p className="admin__item__text">{data.name}</p>
                                </div>

                                {/** Options **/}
                                <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                                    {/** Modifier **/}
                                    <button
                                        title="Modifier le fichier"
                                        aria-label="Modifier le fichier"
                                        className="admin__item__optbtn"
                                        onClick={() => this.setState({
                                            activeModal: true,
                                            activeFile: data.id,
                                            form: {
                                                name: data.name,
                                                code: data.code
                                            }
                                        })}
                                    >
                                        <FontAwesomeIcon icon={faPen} />
                                    </button>

                                    {/** Supprimer **/}
                                    <button
                                        title="Supprimer le fichier"
                                        aria-label="Supprimer le fichier"
                                        className="admin__item__optbtn admin__item__optbtn--del"
                                        onClick={(el) => this.handleDeleteFile(el, data.id)}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </button>
                                </div>
                            </li>
                        })
                    }
                </ul>
            }
        
            {/** Modal **/}
            {
                this.state.activeModal &&
                <div className="codemod">
                    <button
                        title="Fermer la modale"
                        aria-label="Fermer la modale"
                        className="codemod__close"
                        onClick={() => this.setState({
                            activeModal: false
                        })}
                    >
                        <FontAwesomeIcon icon={faXmarkCircle} />
                    </button>

                    {/** Nom **/}
                    <div className="codemod__inpgrp">
                        <label htmlFor="file-name" className="codemod__lab">Nom&nbsp;:</label>
                        <input
                            type="text"
                            id="file-name"
                            placeholder="Nom du fichier"
                            title="Nom du fichier"
                            aria-label="Nom du fichier"
                            className="codemod__inp"
                            value={this.state.form.name}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        name: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Code **/}
                    <div className="codemod__inpgrp">
                        <label htmlFor="file-code" className="codemod__lab">Code&nbsp;:</label>
                        <textarea
                            type="text"
                            id="file-code"
                            placeholder="Code"
                            title="Code"
                            aria-label="Code"
                            className="codemod__inp codemod__inp--text"
                            value={this.state.form.code}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        code: el.target.value
                                    }
                                }))
                            }}
                        ></textarea>
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Enregistrer le fichier"
                        aria-label="Enregistrer le fichier"
                        className="codemod__btn"
                        onClick={(el) => this.handleSaveFile(el)}
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </button>
                </div>
            }
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redCdFldSave: state.redCdFldSave,
        redCdFldDel: state.redCdFldDel,
        redCdFlSave: state.redCdFlSave,
        redCdFlDel: state.redCdFlDel
    }
}

const mapDispatchToProps = {
    getCodeFolderSave,
    getCodeFolderDelete,
    getCodeFileSave,
    getCodeFileDelete
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemFolder);

// todo : + ajouter fichier + ajouter dossier
// todo : faire la modale de fichier